import React, { FC, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { RootState, useDispatch, useSelector } from 'src/store';
import { pagesReset } from 'src/store/modules/pages';
import {
  editTextReset,
  editColor,
  editFontSize,
  editFontWeight,
  editPreFontSize,
  editText
} from 'src/store/modules/editText';
import {
  buttonsReset,
  editBtnBgColor,
  editBtnColor,
  editBtnFontWeight,
  editBtnPreFontSize,
  editBtnText
} from 'src/store/modules/buttons';
import {
  imageReset,
  editBgImage,
  editRadius,
  editCurrentIndex,
  editDeeplink
} from 'src/store/modules/imageUpload';
import { useParams } from 'react-router';
import { API, Auth } from 'aws-amplify';
import setInitValue from 'src/utils/setInitValue';
import { changeText } from 'src/utils/changeText';
import { changeEnter } from 'src/utils/changeEnter';
import { initTrackingValues } from '../TemplateTracking/ModalSlideTracking';
import { editUserCompany } from 'src/store/modules/client';
import { trackingReset } from 'src/store/modules/trackings';
import { getFontURL } from 'src/utils/getFontUrl';

const initValue = {
  currentIndex: 0,
  bg: 'color',
  bgImage: {
    multi_image: [
      'https://image.inappmessage.com/sample/defaultGRAYIMAGE.webp',
      'https://image.inappmessage.com/sample/defaultGRAYIMAGE.webp',
      'https://image.inappmessage.com/sample/defaultGRAYIMAGE.webp'
    ]
  },
  bgColor: { background: '#ffffff' },
  radius: { background: 10, multi_image: 16, multi_button: 0 },
  deeplink: {
    multi_image: [
      'https://www.inappmessage.com/',
      'https://www.inappmessage.com/',
      'https://www.inappmessage.com/'
    ]
  },

  text: {
    multi_title: ['SALE UP TO 30%', 'SALE UP TO 40%', 'SALE UP TO 50%'],
    multi_sub_title: [
      'Get a designer brand products at a sale price. Give away a 10$ coupon for members. Get a designer brand products at a sale price. Give away a 10$ coupon for members. Get a designer brand products at a sale price. Give away a 10$ coupon for members.Get a designer brand products at a sale price. Give away a 10$ coupon for members. Get a designer brand products at a sale price. Give away a 10$ coupon for members. Get a designer brand products at a sale price. Give away a 10$ coupon for members.',
      'Get a designer brand products at a sale price. Give away a 10$ coupon for members.',
      'Get a designer brand products at a sale price. Give away a 10$ coupon for members.'
    ]
  },
  fontSize: { multi_title: 1.5, multi_sub_title: 0.75 },
  fontWeight: { multi_title: 700, multi_sub_title: 400 },
  color: { multi_title: '#000000', multi_sub_title: '#000000' },
  fontFamily: { multi_title: 'Montserrat', multi_sub_title: 'Montserrat' },
  textAlign: { multi_title: 'center', multi_sub_title: 'center' },

  btnText: { multi_button: ['SHOW UP 1', 'SHOW UP 2', 'SHOW UP 3'] },
  btnFontSize: { multi_button: 1 },
  btnFontWeight: { multi_button: 500 },
  btnColor: { multi_button: '#ffffff' },
  btnBgColorR: { multi_button: 0 },
  btnBgColorG: { multi_button: 0 },
  btnBgColorB: { multi_button: 0 },
  btnBgColorA: { multi_button: 1 },
  btnFontFamily: { multi_button: 'Montserrat' }
};

const ModalSlide: FC<any> = () => {
  const dispatch = useDispatch();
  const sliderRef = useRef<any>(null);
  const contentsSliderRef = useRef<any>(null);
  useEffect(() => {
    async function getUserId() {
      try {
        const current = await Auth.currentUserInfo();
        dispatch(editUserCompany(current.attributes['custom:Company']));
      } catch (error) {
        console.log('error');
      }
    }
    getUserId();
  }, []);
  let clientName = useSelector((state: RootState) => state.client.userCompany);

  let currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  let bg = useSelector((state: RootState) => state.imageUpload.bg);
  let bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  let bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  let radius = useSelector((state: RootState) => state.imageUpload.radius);

  let text = useSelector((state: RootState) => state.editText.text);
  let fontSize = useSelector((state: RootState) => state.editText.fontSize);
  let fontWeight = useSelector((state: RootState) => state.editText.fontWeight);
  let color = useSelector((state: RootState) => state.editText.color);
  let fontFamily = useSelector((state: RootState) => state.editText.fontFamily);
  let textAlign = useSelector((state: RootState) => state.editText.textAlign);

  let btnText = useSelector((state: RootState) => state.buttons.btnText);
  let btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  let btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  let btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  let btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  let btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  let btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  let btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  let btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );
  const multiTitleFontURL = getFontURL(fontFamily?.multi_title);
  const multiSubTitleFontURL = getFontURL(fontFamily?.multi_sub_title);
  const multiButtonURL = getFontURL(btnFontFamily?.multi_button);
  // const multiTitleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.multi_title}`;
  // const multiSubTitleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.multi_sub_title}`;
  // const multiButtonURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.multi_button}`;
  const { id } = useParams<{ id: string }>();
  useEffect(() => {
    async function onLoad() {
      try {
        if (id) {
          const { customValues } = await API.get(
            'iam-editor',
            `/templates/${id}`,
            ''
          );
          if (
            customValues?.bgImage &&
            customValues?.text &&
            customValues?.btnText
          ) {
            setInitValue(dispatch, customValues);
          } else {
            setValue(
              dispatch,
              customValues,
              { ...initValue, ...initTrackingValues },
              clientName
            );
          }
        }
      } catch (error) {}
    }
    setInitValue(dispatch, { ...initValue, ...initTrackingValues });
    onLoad();
    return () => {
      dispatch(buttonsReset());
      dispatch(editTextReset());
      dispatch(imageReset());
      dispatch(pagesReset());
      dispatch(trackingReset());
    };
  }, []);

  const closeImageUrl =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAMAAADVRocKAAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABaUExURQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB4eHh8fHy0tLS4uLqamprW1teLi4uPj4/Ly8oZg+lAAAAAUdFJOUwAQIDBAUF9gb3CPkJ+gr7C/z9/vMBy4TQAAAvhJREFUaN7FmtuaqyAMhYO1ZVMdR2H1LO//mvvCdkZbhITSb9Ztdf2VQAgHIpZUbfbdYB0AONt3e1MrKiWlW4uAhlZXBdxNj4j6Nxl11H1St83/8xYsWZ3l/8+BrQxEbSGSEFF1EKsVhHvnkCH2R6g9MrVnDb7KIluW0UwbhzdkN8nmx5vaJTo/3pb5sH+UsEMRrbbSBoW0Kd8/l3LB3qqK+QM2NOL2KKj9q79GUe0+F4CVMLQorO6jDQQA9QIQaKDjdfSXY9po7Tmb+IDj6L334znlf56eO8ZTRuADLt5zCJO/99dAnFU0At5zCA9/P0azXqiLjhzCj7/3iERhG3r36tOEmf8l1pGCNcphTBJm/rdDsHK9D+Lk62HC3P8U9lDRQZYgMPzvYe6RQ+D4T21UsTrJM4HlP7WRRgaB6Q+dyqMrBK4/WiIaICaw/WGJFCAl8P0BRTWkBIk/ajIQEkT+MNRARpD5oyHOYmlOkPnjmxgr4QVB5o+BeOXKK4HnD0vMBc0zgekPR9wqZEng+gNswILA988EpKsZOWDZRHxCbpC5BJfdTZkEm8jWkYHGI/TSVHEbZYRvYbK7nc4yQiNL17cTo156Ste10F9IqCVT5mP8SgiKEv00OL/wCQMRfYn9BYSWX3gt8xuXoClat0TmXyah4ha/r/mZRZgWCCbHn0eYNjpVlj+LcN9PCLbRMV2fzAnHcCK671OHfrww5scZ4Rr6fRtbxrLm31/CGFvGBsM8sub3X8JqiImIlFtdJ6fqhwfhEt8NMWvr5HR9MhFC62Sd2M45XPztekhPKWvP2eWBR/kNqafThK60f/u8KejK+r+eJOiPNhARccoLvpq/2FouGIa1o5xPb+8XC3TkPM2U8I8e4pgP+xdopeR54+at3uo2f3/USKSyx3TDvamgsz7CCc6sqy+5fye7nyD9CFuLT/UlCGey7iVwEdZkX0PZMmbSvqZ3VOn41RNT4A5Npb+C2wG21QVv6NSm6frH9Z+ha9jXf/4D6/hXXVtJWDsAAAAASUVORK5CYII=';
  const style = `
  @font-face {
    font-family: 'multiTitle';
    src: url(${multiTitleFontURL});
  }
  @font-face {
    font-family: 'multiSubTitle';
    src: url(${multiSubTitleFontURL});
  }
  @font-face {
    font-family: 'multiButton';
    src: url(${multiButtonURL});
  }
  .root_view {
    width: 100%;
    height: 100%;

    overflow: hidden;
    position: relative;
    background: none;
    display: flex;
    justify-content: center;

    .background {
      width: 100%;
      height: 100%;

      position: absolute;
      top: 0;
      background: rgba(0, 0, 0, 0.8);
    }
    .modal_wrapper {
      width: calc(100% - 76px);            
      padding: 1rem 0;

      display: flex;
      flex-direction: column;
      gap: 1rem;

      overflow: hidden;
      position: absolute;
      top: 50%;
      transform: translate(0%, -50%);
      
      border-radius: ${radius?.background}px;
      ${
        bg === 'image'
          ? `background-image: url(${bgImage?.background});`
          : `background: ${bgColor?.background};`
      };

      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    }

    .close_btn {
      position: absolute;
      right: 10%;
      top: 6%;
    }
    .close_btn button {
      width: 1.5rem;
      height: 1.5rem;
      
      background-image: url(${closeImageUrl});
      background-repeat: no-repeat;
      background-size: 1.5rem;
      background-position: center;

      font-size: 0;
      border: none;
      background-color: transparent;
    }

    .slick_wrapper,
    .slick_wrapper .slick-slider,
    .slick_wrapper .slick-list {
      width: 100%;
      height: 12rem;
    }
    .slick_wrapper .slick_image_wrapper {
      max-width: 12rem;
      width: 12rem;
      min-width: 12rem;
      max-height: 12rem;
      height: 12rem;
      min-height: 12rem;
      outline: 0;
    }
    .slick_image_wrapper img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      aspect-ratio: 1;
      outline: 0;
      border-radius: ${radius?.multi_image}px;
    }

    .slick_wrapper .slick-list {
      padding: 0 -0.5rem;
    }
    .slick_wrapper .slick-track {
      display: flex;
    }
    .slick_wrapper .slick-slide {
      padding: 0 0.5rem;
    }
    .slick_wrapper .slick-track img {
      object-fit: cover;
      border-radius: ${radius?.multi_image}px;
    }

    .contents_wrapper,
    .contents_wrapper .slick-slider,
    .contents_wrapper .slick-list,
    .contents_wrapper .slick-track div,
    .contents_wrapper .slick-track img {
      background-color: transparent;
    }
    .contents_wrapper {
      width: 100%;
      height: 8rem;
      padding: 0 1rem;
    }
    .contents_box {
      height: 8rem;
    }
    .contents_box .title {
      width: 100%;
      height: 3rem;      

      display: flex;
      align-items: center;
    }
    .title .title_inner {
      width: 100%;
      text-align: ${textAlign?.multi_title};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      color: ${color?.multi_title};
      font-size: ${fontSize?.multi_title}rem;
      font-weight: ${fontWeight?.multi_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.multi_title
        )
          ? fontFamily.multi_title
          : 'multiTitle'
      };
    }
    .contents_box .sub_title {
      width: 100%;
      height: 4.5rem;

      display: flex;
      align-items: center;
    }
    .contents_box .sub_title_inner {
      width: 100%;  
      text-align: ${textAlign?.multi_sub_title};
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;

      color: ${color?.multi_sub_title};
      font-size: ${fontSize?.multi_sub_title}rem;
      font-weight: ${fontWeight?.multi_sub_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.multi_sub_title
        )
          ? fontFamily.multi_sub_title
          : 'multiSubTitle'
      };
    }

    .dot_wrapper {
      margin-top: 1rem;
    }
    .dot_wrapper,
    .dot_wrapper li {
      height: 0.25rem;      
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 1rem;
      list-style-type: none;
    }
    .dot_wrapper button {
      width: 0.25rem;
      height: 0.25rem;

      font-size: 0;
      border: 0;
      outline: 0;
      border-radius: 999px;
      background-color: rgba(0, 0, 0, .3);
    }
    .dot_wrapper li.slick-active button {
      background-color: #000;
    }

    .bar_blank {
      width: 100%;
      height: 0.25rem;
    }
    .btn_wrapper {
      width: 100%;
      padding: 0 1rem;
    }
    .btn_wrapper button {
      width: 100%;
      height: 3rem;
      outline: 0;
      border: 0;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      font-size: ${btnFontSize?.multi_button}rem;
      font-weight: ${btnFontWeight?.multi_button};
      color: ${btnColor?.multi_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.multi_button
        )
          ? btnFontFamily.multi_button
          : 'multiButton'
      };
      border-radius: ${radius?.multi_button}px;
      background-color:rgba(${btnBgColorR?.multi_button},${
    btnBgColorG?.multi_button
  }, ${btnBgColorB?.multi_button}, ${btnBgColorA?.multi_button});
    }

  }
  `;

  useEffect(() => {
    sliderRef.current.slickGoTo(currentIndex);
    contentsSliderRef.current.slickGoTo(currentIndex);
  }, [currentIndex]);

  const settings = {
    arrows: false,
    dots: false,

    centerMode: true,
    slidesToShow: 1,
    slidesToScroll: 0,
    variableWidth: true,
    speed: 300,
    touchThreshold: 300
  };

  const contentsSettings = {
    arrows: false,
    dots: true,
    fade: true,
    swipe: false,

    dotsClass: 'dot_wrapper',
    appendDots: dots => <div id="id_dot_wrapper">{dots}</div>,
    speed: 300
  };

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }}></style>
      <div className="root_view">
        <div className="background"></div>
        <div className="close_btn">
          <button>close</button>
        </div>
        <div className="modal_wrapper">
          <div className="slick_wrapper">
            <Slider
              {...settings}
              ref={sliderRef}
              afterChange={index => {
                dispatch(editCurrentIndex(index));
                contentsSliderRef.current.slickGoTo(index);
              }}
            >
              {bgImage?.multi_image?.map((data: any, idx: number) => {
                return (
                  // <div key={idx} className="slick_image_wrapper">
                  <img
                    key={idx}
                    className="slick_image_wrapper"
                    src={data}
                    alt="이미지"
                    decoding="async"
                    loading="lazy"
                  />
                  // </div>
                );
              })}
            </Slider>
          </div>
          <div className="contents_wrapper">
            <Slider {...contentsSettings} ref={contentsSliderRef}>
              {text?.multi_title?.map((data: any, idx: number) => {
                return (
                  <div key={idx} className="contents_box">
                    <div className="title">
                      <div className="title_inner">
                        {changeEnter(text?.multi_title?.[idx])}
                      </div>
                    </div>
                    <div className="sub_title">
                      <div className="sub_title_inner">
                        {changeEnter(text?.multi_sub_title?.[idx])}
                      </div>
                    </div>
                  </div>
                );
              })}
            </Slider>
          </div>
          <div className="bar_blank" />
          <div className="btn_wrapper">
            <button>{btnText?.multi_button?.[currentIndex]}</button>
          </div>
        </div>
      </div>
    </>
  );
};

const setValue = (
  dispatch: any,
  values: any,
  initValues: any,
  clientName: any
) => {
  const MultiBackground = values?.imageName?.map((data: any) => {
    return `https://image.inappmessage.com/${clientName}/${data}`;
  });
  dispatch(
    editBgImage({
      multi_image: MultiBackground
    })
  );
  //  dispatch(editBgImageBlur(values?.bgImageBlur));
  dispatch(
    editDeeplink({
      multi_image: values?.newDeepLink
    })
  );
  dispatch(
    editRadius({
      background: values?.newBodyRadius,
      multi_image: values?.newImgRadius,
      multi_button: values?.newBtnRadius
    })
  );

  const newText = values?.newText?.map((data: any) => {
    return changeText(data);
  });
  const newSubText = values?.newSubText?.map((data: any) => {
    return changeText(data);
  });
  dispatch(
    editText({
      multi_title: newText,
      multi_sub_title: newSubText
    })
  );
  dispatch(
    editPreFontSize({
      multi_title: values?.newFontSize / 16,
      multi_sub_title: values?.newSubFontSize / 16
    })
  );
  dispatch(
    editFontSize({
      multi_title: values?.newFontSize / 16,
      multi_sub_title: values?.newSubFontSize / 16
    })
  );
  dispatch(
    editFontWeight({
      multi_title: values?.newFontWeight,
      multi_sub_title: values?.newSubFontWeight
    })
  );
  dispatch(
    editColor({
      multi_title: values?.newTextColor,
      multi_sub_title: values?.newSubTextColor
    })
  );
  // dispatch(editFontFamily(values?.fontFamily));
  // dispatch(editTextAlign(values?.textAlign));

  const newBtnText = values?.newBtnText?.map((data: any) => {
    return changeText(data);
  });
  dispatch(
    editBtnText({
      multi_button: newBtnText
    })
  );
  dispatch(
    editBtnPreFontSize({
      multi_button: values?.newBtnFontSize / 16
    })
  );
  dispatch(
    editPreFontSize({
      multi_button: values?.newBtnFontSize / 16
    })
  );
  dispatch(
    editBtnFontWeight({
      multi_button: values?.newBtnFontWeight
    })
  );
  dispatch(
    editBtnColor({
      multi_button: values?.newBtnTextColor
    })
  );
  dispatch(
    editBtnBgColor(
      { multi_button: values?.BtnBgColorR },
      { multi_button: values?.BtnBgColorG },
      { multi_button: values?.BtnBgColorB },
      { multi_button: values?.BtnBgColorA }
    )
  );
  //     dispatch(editBtnFontFamily(values?.btnFontFamily));
  //     dispatch(editBtnTextAlign(values?.btnTextAlign));
};

export default ModalSlide;
